module.exports = __webpack_public_path__ + "static/media/bgnew.5366ecf2.jpg";